import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommonService } from '../../shared/services/common.service';
import { ApiResponseModel } from '../../admin/models/apiResponseModel';
import { LoginWithOtpReturnModel } from '../models/loginWithOtpReturnModel';
import { LoginWithOtpBindingModel } from '../models/loginWithOTPBindingModel';
import { map } from 'rxjs/operators';
import { ConfirmOtpBindingModel } from '../models/confirmOtpBindingModel';



const LOGIN_OTP_URL = 'Auth/accounts/web/login/otp';
const LOGIN_OTP_CONFIRM_URL = 'Auth/accounts/web/login/otp/confirm';

@Injectable({
  providedIn: 'root'
})

export class NewAuthService {

  constructor(
    private http: HttpClient,
    private commonService: CommonService) { }

  loginWithOtpCode(model: LoginWithOtpBindingModel): Promise<ApiResponseModel<LoginWithOtpReturnModel>> {
    const httpHeaders = new HttpHeaders();
    httpHeaders.set("Content-Type", "application/json");
    return this.http.post<ApiResponseModel<LoginWithOtpReturnModel>>(`${this.commonService.getApiEndpoint()}/${LOGIN_OTP_URL}`, model, { headers: httpHeaders })
    .pipe(map(res => res['result'] as ApiResponseModel<LoginWithOtpReturnModel>))
    .toPromise();
  }


  confirmAndLogin(model: ConfirmOtpBindingModel): Promise<any> {
    return this.http.post<any>(`${this.commonService.getApiEndpoint()}/${LOGIN_OTP_CONFIRM_URL}`, model)
    .pipe(map(res => res['result'] as any))
    .toPromise();
  }

}
